import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { useState as v } from "react";
import { ProductCardUnavailable as O } from "../ProducCardUnavailable/index.js";
import { ProductCardBadgeKg as M } from "../ProductCardBadge/ProductCardBadgeKg.js";
import { ProductCardDiscountBadge as N } from "../ProductCardBadge/ProductCardDiscountBadge.js";
import { ProductCardButton as y } from "../ProductCardButton/index.js";
import { ProductCardImage as D } from "../ProductCardImage/index.js";
import { ProductCardName as U } from "../ProductCardName/index.js";
import { ProductCardPrice as b } from "../ProductCardPrice/index.js";
const V = ({
  hasPlusFriendBadge: r,
  promotion: d,
  product: i,
  hasPromotionalPrice: o,
  clubPrice: f,
  outOfStock: P,
  variant: s,
  defaultScListPrice: a,
  isClubClient: c,
  hasClub: p,
  openModal: C,
  addToCartAction: g,
  quantitySelectorAction: S,
  productInCart: h
}) => {
  var u, l;
  const [k, m] = v(!1);
  if (P)
    return /* @__PURE__ */ e(
      O,
      {
        image: (u = i.image) == null ? void 0 : u[0],
        name: i.name,
        variant: s
      }
    );
  const n = c && i.hasClubPrice;
  return /* @__PURE__ */ t("div", { id: "product-card", children: [
    /* @__PURE__ */ e("div", { className: "product-card", children: /* @__PURE__ */ t("div", { className: "product-card-container", onClick: C, children: [
      /* @__PURE__ */ e(
        D,
        {
          isProductClubAndClient: n,
          variant: s,
          hasPlusFriendBadge: r,
          promotion: d,
          image: (l = i.image) == null ? void 0 : l[0]
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          className: "product-card-description",
          style: {
            backgroundColor: n ? "#FDF3DE" : "var(--color-grayScale-faded)"
          },
          children: [
            /* @__PURE__ */ t("div", { className: "product-card-section-name", children: [
              /* @__PURE__ */ e(U, { name: i.name }),
              /* @__PURE__ */ t(
                "div",
                {
                  className: "product-card-section-badge",
                  style: { display: k ? "" : "none" },
                  children: [
                    /* @__PURE__ */ e(
                      M,
                      {
                        unitMultiplier: i.unitMultiplier,
                        skuSpecifications: i.skuSpecifications,
                        measurementUnit: i.measurementUnit,
                        setIsShowProductBadge: m
                      }
                    ),
                    /* @__PURE__ */ e(
                      N,
                      {
                        defaultScListPrice: a,
                        nativeListPrice: i.customOffers.listPriceCustom,
                        nativeSpotPrice: i.customOffers.spotPriceCustom,
                        skuSpecifications: i.skuSpecifications,
                        unitMultiplier: i.unitMultiplier,
                        hasPromotionalPrice: o,
                        setIsShowProductBadge: m
                      }
                    )
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e(
              b,
              {
                hasClub: p,
                isClubClient: c,
                unitMultiplier: i.unitMultiplier,
                hasPromotionalPrice: o,
                measurementUnit: i.measurementUnit,
                skuSpecifications: i.skuSpecifications,
                customOffers: {
                  listPriceCustom: i.customOffers.listPriceCustom,
                  hasDiscount: i.customOffers.hasDiscount,
                  spotPriceCustom: i.customOffers.spotPriceCustom,
                  spotPriceKg: i.customOffers.spotPriceCustom
                },
                defaultScListPrice: a,
                clubPrice: f,
                hasPlusFriendBadge: r
              }
            )
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ e(
      y,
      {
        addToCartAction: g,
        quantitySelectorAction: S,
        productInCart: h,
        layout: s
      }
    )
  ] });
};
export {
  V as ProductCardVertical
};
